document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.testimonials-carousel').forEach(carousel => {
    const slides = carousel.querySelectorAll('.tc-slide');
    const prev = carousel.querySelector('.tc-prev');
    const next = carousel.querySelector('.tc-next');

    if (!slides.length) return;

    let index = 0;

    function showSlide(i) {
      slides.forEach(s => s.classList.remove('active'));
      slides[i].classList.add('active');
    }

    showSlide(index);

    next.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      showSlide(index);
    });

    prev.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
    });
  });
});
